import React from 'react';
import { Button } from 'reactstrap';
import {
  Link,
  withRouter,
  RouteComponentProps,
  matchPath,
} from 'react-router-dom';

const NewPatientButton = (
  props: RouteComponentProps<{ organizationId: string }>,
) => {
  const match = matchPath<{ organizationId: string }>(props.location.pathname, {
    path: '/organization/:organizationId',
  });
  const organizationId = match ? match.params.organizationId : null;
  return (
    <Button
      tag={Link}
      outline
      color="success"
      className="text-center"
      to={`/organization/${organizationId}/newPatient`}
      disabled={!organizationId}>
      New Patient
    </Button>
  );
};

export default withRouter(NewPatientButton);
